var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 27,
    height: 27,
    fill: "url(#pattern0_23_299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_23_299",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_23_299",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_23_299",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFC0lEQVR4nO2cTYgcRRTHy28FNRIR0YOiiV+DmfeaMSoRXWKMF71pvKgHQdZTBA/LzqteHFDw4xQRQTd60JugKBEEBY2beBM8RYyohEUNGDZO1exuvIi2VM/2pumP2c70x1ZPvx80DLv/2df125runtc1IwTDMAzDMAzDMEzT0YR7NcG7ivAnLXHVbErCcS3xoHbxobrWsoZBt32rJjiiJXqjN1gYzOEtdallFX3XeUBL7G888PWt36cd99teyyr82XVuA/fMpgj/0l1nu621rENLPHyuA9fBRnDE1lpW4Z+Mxh24DGabs8e2WtahJbyXd/CacN62WtaxdlmVb5ZJOG5bLevQhCsFzLIV22pZRzGDh4FttayjkJczwY+21bIO8/Y3/3ET37GtlnWYfkLuwbvtB22rZSWa8OvxBw8LttayDuW2b1IES1W8LVYV1rIS07TxByOzD3zsplKFtazEtCM14TcZBn847+yqspa1KHL2mLe65lLKv/YlXFl7PF/0yajKWgzDMAzDMA1CEew2aynUcE3Fat6exNgboVIS3/rthXsvE5OEdjvb8vUfsJSttl26JAYu7lISTm+2VJ04s+GM1xPnR/fZ67UuVrNtR9RpJlsrWaaLXpq57QpFeMo0p0QdsPFwocOHDoK3k/Z7ec65Y3hogc+F7ZgewmaL1OlbX0l4M+1kqCVMB1mztEzYjL9Ss8jZJ6tbAhB+JabNemso4iap3gTRa5eg4drHhM0UcttfVita91pblYRfIrWXhc0UfuKS5Yo2krXEo0m1hc3USbQi2J0wk1l0Xk71WpcPL+FgOsslqLCZKme0LrgWi06BRfOMLh8+dFQEi64IFl0RLLoiWHRFsOiKYNEVwaIrgkVXBIuuCBZdESy6IpTEP7PJhoVlwmsG3fY95hOr47VJ4WSmVivBz7q742Z/vQnBrxn376SwGU14INNAXHjy7HPg47FEE76WUfRLwXOUxJcz9sFfFTbj9aYuNWsnzILCkYPpwsPBc8yt/XFEmyVcQ9mjZ/ZA4vPBc8zjjWay+Zvmb4s6EKz6SReNO4OsInhlHNFhRoruOk8HOfN4VFbUjQ1Fu51tQVZJmClVtIRHgtyg2360WaJ7ra1BVkl8tlTRLu5a3y+C+xojWhH+6+3bd0GQVdJ5rEzRy9S5fX2/CFuNEa0JVdaFkUWIXqE7rw1yq7JzXZNEnwhnlQQsU7S3f/slQc48bpLo78PZvuvcWJpogjPxLPzdDNESvgpnT/fuvrI80fhHPJt+3S0mTPRH4awnxHmK4J+SDh2x5bea8IeGiMaD0XzaZ14KEH00liX8timiX4/m01Z15hcNh2JZws+aIZqwG80rCd+VJPr9WJbgg4aIhueieSXxy5JOhgfiWXijKaKfiOYV4YcliX4xIdtriGjcG82ntUrzi3b2R7OjWqVisk6Gzl3RfFqrNK/oAcFT0eyoVqmYKNHu2RbpRq3S3KJDLdIsrVIxSaIH3Z1XR/NprdK8ok1bNLZvI1qlom4szTjXJ4ojWEr6wHufcCo5j19kqacJFuP/JPwv3LkLMD8zv0s4SS+KOpJ0yaZSbnr69/8kHksQ/XiWWppgLuEf9WlqXsKheB5cUUdUD67yv8xvuAThd3MH2pvuXJSW7892btCEn2gJ2hwyVBeeyVrL601d6MsmWPS/n5Rwvj/b2TKi1hb/W3H8rHk1gBu+GcEwDMMwDCNqzf+B37LDaE4qPQAAAABJRU5ErkJggg=="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/Friends.ef4a70b23963ac36aef1afd35406ab7b.svg";
export { ForwardRef as ReactComponent };